module.exports = __webpack_public_path__ + "img/level-3-active.76fec79e.svg";